// Declarative routing
import { useQuery } from '@apollo/client';
import { Box, Grid, Link, makeStyles } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
// Material ui components
// Apollo client

// Image
import CardServiceProvider from '../../../../../components/CardServiceProvider';
import Subtitle from '../../../../../components/Subtitle';
import { useAuthContext } from '../../../../../context/AuthContextProvider';
import ipanema from '../../../../../graphql/clients/ipanema';
import {
  GET_CRA_SERVICE_PROVIDERS_BY_OPERATION_HASH_ID,
  GET_INSTITUTION_BY_CNPJ,
} from '../../../../../graphql/queries';

// Styles
const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: theme.typography.fontWeightBold,
  },
  divider: {
    height: 2,
    backgroundColor: theme.palette.common.black,
  },
}));

function CardServiceProviderWrap({ title, name, logo, cnpj }) {
  const { data, loading, error } = useQuery(GET_INSTITUTION_BY_CNPJ, {
    variables: { cnpj },
  });

  if (loading) return null;
  if (error) return null;

  return (
    <Link
      component={RouterLink}
      underline="none"
      to={`/instituicao/${data.findInstitutionByCnpj?.slug}/${data.findInstitutionByCnpj?.hashId}`}>
      <CardServiceProvider title={title} name={name} logo={logo} link />
    </Link>
  );
}

export default function OperationCRAResumeServiceProvider({ hashId }) {
  const { auth } = useAuthContext();
  const classes = useStyles();
  const { data, loading, error } = useQuery(
    GET_CRA_SERVICE_PROVIDERS_BY_OPERATION_HASH_ID,
    {
      variables: { hash: hashId },
      client: ipanema,
    },
  );

  const canViewServiceProviders =
    auth?.user?.subscription?.plan?.permissions[
      'operacoes_cra_prestadores_de_servicos'
    ];

  return (
    <Box p={1}>
      <Subtitle title="Prestadores de Serviço" />
      <Box py={4}>
        {loading || error ? null : (
          <Grid container spacing={1}>
            {data.getCraServiceProvidersByOperationHashId.fiduciaryAgents
              .length > 0 &&
              data.getCraServiceProvidersByOperationHashId.fiduciaryAgents.map(
                ({ logo, name, cnpj }) => (
                  <Grid item xs={12} sm={6} md={12} lg={6} key={cnpj}>
                    <CardServiceProviderWrap
                      classes={classes}
                      title="Agente Fiduciário"
                      logo={logo}
                      name={name}
                      cnpj={cnpj}
                    />
                  </Grid>
                ),
              )}
            {data.getCraServiceProvidersByOperationHashId.auditors.length > 0 &&
              data.getCraServiceProvidersByOperationHashId.auditors.map(
                ({ logo, name, cnpj }) => (
                  <Grid item xs={12} sm={6} md={12} lg={6} key={cnpj}>
                    <CardServiceProvider
                      alert={!canViewServiceProviders}
                      lock={!canViewServiceProviders}
                      title="Auditor"
                      logo={logo}
                      name={name}
                    />
                  </Grid>
                ),
              )}
          </Grid>
        )}
      </Box>
    </Box>
  );
}
